import styled, { css } from 'styled-components';
import { PrimaryButton } from '../../../components/Button';
import ScrollableWrapper from '../../../components/ScrollableWrapper';
import { theme } from '../../../styles/theme';
import { SEARCH_MENU_HEIGHT, SEARCH_MENU_WIDTH } from './utils';

export const Container = styled.div`
  display: flex;
  width: ${SEARCH_MENU_WIDTH}px;
  height: ${SEARCH_MENU_HEIGHT}px;
`;
export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100%;
`;
export const StaticWrapper = styled.div<{ $hasBorder?: boolean }>`
  display: flex;
  align-items: center;
  flex: 0 0 48px;
  padding-right: 8px;
  padding-left: 8px;
  ${({ $hasBorder }) =>
    $hasBorder &&
    css`
      border-bottom: 1px solid ${theme.colors.border};
    `}
`;
export const EmptyResult = styled.div`
  flex: 1;
  padding-top: 60px;
  padding-bottom: 24px;
  text-align: center;
  color: ${theme.colors.secondary600};
  font-size: 14px;
  font-weight: 400;
`;
export const StyledContent = styled(ScrollableWrapper)`
  flex: 1 1 0;
`;
export const LoadMoreButton = styled(PrimaryButton)`
  flex: 1;
  width: 100%;
  margin-top: 5px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;
